/**
 * Flat keys preserved for backwards compatibility (`t('email')`, etc.).
 */
export const legacyFlat = {
  fr: {
    dashboard: 'Tableau de bord',
    courses: 'Cours',
    students: 'Étudiants',
    trainers: 'Formateurs',
    schedule: 'Emploi du temps',
    classrooms: 'Salles',
    payments: 'Paiements',
    benefits: 'Bénéfices',
    reports: 'Rapports',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    search: 'Rechercher',
    filter: 'Filtrer',
    export: 'Exporter',
    import: 'Importer',
    loading: 'Chargement...',
    login: 'Se connecter',
    email: 'Email',
    password: 'Mot de passe',
    rememberMe: 'Se souvenir de moi',
    forgotPassword: 'Mot de passe oublié ?',
    studentName: "Nom de l'étudiant",
    studentCode: 'Code étudiant',
    phone: 'Téléphone',
    address: 'Adresse',
    birthDate: 'Date de naissance',
    joinDate: "Date d'inscription",
    status: 'Statut',
    active: 'Actif',
    inactive: 'Inactif',
    courseType: 'Type de cours',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    price: 'Prix',
    duration: 'Durée',
    courseTitle: 'Titre du cours',
    courseDescription: 'Description du cours',
    classroomName: 'Nom de la salle',
    classroomType: 'Type de salle',
    capacity: 'Capacité',
    amount: 'Montant',
    paymentMethod: 'Méthode de paiement',
    paymentDate: 'Date de paiement',
    invoice: 'Facture',
    totalStudents: 'Total des étudiants',
    activeStudents: 'Étudiants actifs',
    monthlyRevenue: 'Revenus mensuels',
    classroomStatus: 'État des salles',
    trainerName: 'Nom du formateur',
    speciality: 'Spécialité',
    experience: 'Expérience',
    scheduleTitle: 'Titre',
    scheduleDate: 'Date',
    scheduleTime: 'Heure',
    trainer: 'Formateur',
    classroom: 'Salle',
  },
  ar: {
    dashboard: 'لوحة القيادة',
    courses: 'الدورات',
    students: 'الطلاب',
    trainers: 'المدربون',
    schedule: 'الجدول الزمني',
    classrooms: 'القاعات',
    payments: 'المدفوعات',
    benefits: 'الأرباح',
    reports: 'التقارير',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    import: 'استيراد',
    loading: 'جاري التحميل...',
    login: 'تسجيل الدخول',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    studentName: 'اسم الطالب',
    studentCode: 'رمز الطالب',
    phone: 'الهاتف',
    address: 'العنوان',
    birthDate: 'تاريخ الميلاد',
    joinDate: 'تاريخ التسجيل',
    status: 'الحالة',
    active: 'نشط',
    inactive: 'غير نشط',
    courseType: 'نوع الدورة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    price: 'السعر',
    duration: 'المدة',
    courseTitle: 'عنوان الدورة',
    courseDescription: 'وصف الدورة',
    classroomName: 'اسم القاعة',
    classroomType: 'نوع القاعة',
    capacity: 'السعة',
    amount: 'المبلغ',
    paymentMethod: 'طريقة الدفع',
    paymentDate: 'تاريخ الدفع',
    invoice: 'الفاتورة',
    totalStudents: 'إجمالي الطلاب',
    activeStudents: 'الطلاب النشطون',
    monthlyRevenue: 'الإيرادات الشهرية',
    classroomStatus: 'حالة القاعات',
    trainerName: 'اسم المدرب',
    speciality: 'التخصص',
    experience: 'الخبرة',
    scheduleTitle: 'العنوان',
    scheduleDate: 'التاريخ',
    scheduleTime: 'الوقت',
    trainer: 'المدرب',
    classroom: 'القاعة',
  },
};
